import {Injectable} from "@angular/core";
import {BehaviorSubject, Observable} from "rxjs";

declare global {
  interface Window {
    _paq: any[];
  }
}

export enum CookieStatus {
  NOT_EVALUATED = 'not_evaluated',
  ACCEPTED = 'accepted',
  REJECTED = 'rejected'
}

@Injectable({
  providedIn: 'root',
})
export class CookieService {
  cookiePolicySubject = new BehaviorSubject<CookieStatus>(CookieStatus.NOT_EVALUATED);


  constructor() {
    window._paq = window._paq || [];

  }

}
